/**
 * Observacao de item de nota para EXIBICAO (tela de fatura e dialog de fatura do PDV).
 *
 * O texto gravado continua completo porque e ele que leva a personalizacao para a factura
 * electronica (SIFEN). Na tela, variantes e modificadores ja aparecem em linhas proprias, entao
 * os trechos "Variantes: ...", "Modificadores: ...", "Variante: ..." e "Adicionais/Adicionales: ..."
 * que web e mobile colocam na observacao sao escondidos para nao aparecerem duplicados.
 *
 * Tambem oculta os valores de preenchimento obrigatorio da nota ('Observação' e o proprio nome
 * do item). Mesma regra do backend (`ItemDeNota.getObservacaoParaExibicao`) e do mobile.
 */
export function observacaoItemParaExibicao(observacao: string | null | undefined, nomeItem?: string): string {
  const obs = (observacao || '').trim();
  if (!obs || obs === 'Observação' || obs === 'Observacao' || obs === (nomeItem || '').trim()) {
    return '';
  }
  return removerPersonalizacao(obs);
}

const SEPARADOR = /(\s+[|-]\s+)/;
const TRECHO_DE_PERSONALIZACAO = /^(variantes?|modificadores|adicionais|adicionales)\s*:/i;

/**
 * Parte o texto nos separadores " | " e " - " e tira os trechos de personalizacao junto com o
 * separador que os ligava. Hifen sem espaco ("Coca-Cola") nao e separador.
 */
function removerPersonalizacao(texto: string): string {
  const partes = texto.split(SEPARADOR);
  const resultado: string[] = [];
  for (let i = 0; i < partes.length; i += 2) {
    if (TRECHO_DE_PERSONALIZACAO.test(partes[i].trim())) continue;
    if (resultado.length > 0) resultado.push(partes[i - 1]);
    resultado.push(partes[i]);
  }
  return resultado.join('').trim();
}
